import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6351_12722)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M69 40C69 23.9837 56.0163 11 40 11C23.9837 11 11 23.9837 11 40C11 56.0163 23.9837 69 40 69C56.0163 69 69 56.0163 69 40ZM71 40C71 57.1208 57.1208 71 40 71C22.8792 71 9 57.1208 9 40C9 22.8792 22.8792 9 40 9C57.1208 9 71 22.8792 71 40Z",
			fill: "#D0D0D2"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M39 22.5C39 21.9477 39.4477 21.5 40 21.5C40.5523 21.5 41 21.9477 41 22.5V39H57.5C58.0523 39 58.5 39.4477 58.5 40C58.5 40.5523 58.0523 41 57.5 41H40C39.4477 41 39 40.5523 39 40V22.5Z",
			fill: "#D0D0D2"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6351_12722",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 80,
			height: 80,
			fill: "white"
		})
	}) })]
});
export default SvgClockBig;
